import React from "react";
import cl from "./Header.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";

const Header = (props) => {
  const { cartItems } = props;

  const navigate = useNavigate();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      navigate("/search");
    }
  };

  const [mobileMenu, setMobileMenu] = useState(cl.mobile_header_links_hidden);
  const [mobileMenuIcon, setMobileMenuIcon] = useState(cl.mobile_menu_icon);
  const [mobileCloseIcon, setMobileCloseIcon] = useState(
    cl.mobile_close_icon_hidden
  );
  let onMenuClick = () => {
    setMobileMenu(cl.mobile_header_links);
    setMobileMenuIcon(cl.mobile_menu_icon_hidden);
    setMobileCloseIcon(cl.mobile_close_icon);
    document.body.classList.add("modal-open");
  };
  let onCloseClick = () => {
    setMobileMenu(cl.mobile_header_links_hidden);
    setMobileMenuIcon(cl.mobile_menu_icon);
    setMobileCloseIcon(cl.mobile_close_icon_hidden);
    document.body.classList.remove("modal-open");
  };
  let onSearchChange = (e) => {
    let text = e.target.value;
    props.updateNewSearchText(text);
  };
  let onSearchClick = () => {};

  return (
    <header
      className={cl.container}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0 20px",
      }}
    >
      <div className={cl.none}></div>
      <NavLink
        className={cl.footer_link}
        to=""
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          textDecoration: "none",
          padding: "10px",
          gap: "10px",
        }}
      >
        <svg
          width="40px"
          height="40px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M3.79424 12.0291C4.33141 9.34329 4.59999 8.00036 5.48746 7.13543C5.65149 6.97557 5.82894 6.8301 6.01786 6.70061C7.04004 6 8.40956 6 11.1486 6H12.8515C15.5906 6 16.9601 6 17.9823 6.70061C18.1712 6.8301 18.3486 6.97557 18.5127 7.13543C19.4001 8.00036 19.6687 9.34329 20.2059 12.0291C20.9771 15.8851 21.3627 17.8131 20.475 19.1793C20.3143 19.4267 20.1267 19.6555 19.9157 19.8616C18.7501 21 16.7839 21 12.8515 21H11.1486C7.21622 21 5.25004 21 4.08447 19.8616C3.87342 19.6555 3.68582 19.4267 3.5251 19.1793C2.63744 17.8131 3.02304 15.8851 3.79424 12.0291Z"
              stroke="#1C274C"
              strokeWidth="1.5"
            ></path>{" "}
            <path
              opacity="0.5"
              d="M9 6V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V6"
              stroke="#1C274C"
              strokeWidth="1.5"
              strokeLinecap="round"
            ></path>{" "}
            <path
              opacity="0.5"
              d="M9.1709 15C9.58273 16.1652 10.694 17 12.0002 17C13.3064 17 14.4177 16.1652 14.8295 15"
              stroke="#1C274C"
              strokeWidth="1.5"
              strokeLinecap="round"
            ></path>{" "}
          </g>
        </svg>
        <h1
          style={{
            textDecoration: "none",
            fontSize: "24px",
          }}
          className={cl.headerTitle}
        >
          {props.aboutData.shopName}
        </h1>
      </NavLink>

      <div
        className={cl.search_bar}
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        >
          <NavLink to="search">
            <button className={cl.search_bar_button} onClick={onSearchClick}>
              <svg
                className={cl.search_bar_button_svg}
                height="50px"
                viewBox="0 0 50 50"
                width="50px"
              >
                <rect fill="none" />
                <circle
                  cx="21"
                  cy="20"
                  fill="none"
                  r="16"
                  stroke="#000000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="2"
                />
                <line
                  fill="none"
                  stroke="#000000"
                  strokeMiterlimit="10"
                  strokeWidth="4"
                  x1="32.229"
                  x2="45.5"
                  y1="32.229"
                  y2="45.5"
                />
              </svg>
            </button>
          </NavLink>
          <input
            type="text"
            value={props.productsPage.newSearchText}
            onChange={onSearchChange}
            onKeyPress={handleKeyPress}
            placeholder="Búsqueda"
            className={cl.input}
          ></input>
        </div>
        <div
          style={{
            width: "62vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className={cl.bottom_line_links}>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to=""
            >
              Casa
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/about"
            >
              Quiénes somos
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/products"
            >
              Productos
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/contacts"
            >
              Contactos
            </NavLink>
          </div>
          <svg
            onClick={onMenuClick}
            className={mobileMenuIcon}
            height="30px"
            viewBox="0 0 512 512"
            style={{ zIndex: "1000" }}
          >
            <title />
            <g data-name="1" id="_1">
              <path d="M441.13,166.52h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
              <path d="M441.13,279.72h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
              <path d="M441.13,392.92h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
            </g>
          </svg>
          <svg
            onClick={onCloseClick}
            className={mobileCloseIcon}
            height="24px"
            id="Layer_1"
            viewBox="0 0 24 24"
            fill="none"
            width="24px"
            style={{ zIndex: "1000" }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M8.00191 9.41621C7.61138 9.02569 7.61138 8.39252 8.00191 8.002C8.39243 7.61147 9.0256 7.61147 9.41612 8.002L12.0057 10.5916L14.5896 8.00771C14.9801 7.61719 15.6133 7.61719 16.0038 8.00771C16.3943 8.39824 16.3943 9.0314 16.0038 9.42193L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.004C15.6133 16.3945 14.9802 16.3945 14.5896 16.004L12.0057 13.42L9.42192 16.0038C9.03139 16.3943 8.39823 16.3943 8.00771 16.0038C7.61718 15.6133 7.61718 14.9801 8.00771 14.5896L10.5915 12.0058L8.00191 9.41621Z"
                fill="#0F0F0F"
              ></path>{" "}
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4ZM21 4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4Z"
                fill="#0F0F0F"
              ></path>{" "}
            </g>
          </svg>
          <div>
            <NavLink
              className={(headerData) =>
                headerData.isActive
                  ? cl.header_link_active_cart
                  : cl.header_link_cart
              }
              to="/cart"
            >
              <div className={cl.cart_items}>
                <svg
                  viewBox="0 0 24 24"
                  width="40px"
                  height="40px"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <path
                      d="M6.29977 5H21L19 12H7.37671M20 16H8L6 3H3M9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20ZM20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20C18 19.4477 18.4477 19 19 19C19.5523 19 20 19.4477 20 20Z"
                      stroke="#000000"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>{" "}
                  </g>
                </svg>
                <p className={cl.cart_items_number}>({cartItems.length})</p>
              </div>
            </NavLink>
          </div>
        </div>
      </div>

      <div className={mobileMenu}>
        <NavLink className={cl.mobile_link} to="/" onClick={onCloseClick}>
          Casa
        </NavLink>
        <NavLink className={cl.mobile_link} to="/about" onClick={onCloseClick}>
          Quiénes somos
        </NavLink>
        <NavLink
          className={cl.mobile_link}
          to="/products"
          onClick={onCloseClick}
        >
          Productos
        </NavLink>
        <NavLink
          className={cl.mobile_link}
          to="/contacts"
          onClick={onCloseClick}
        >
          Contactos
        </NavLink>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          width: "100%",
          paddingBottom: "10px",
          paddingTop: "10px",
        }}
      >
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <svg
            viewBox="0 -4 28 28"
            fill="none"
            width="20px"
            height="20px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g clipPath="url(#clip0_503_3600)">
                {" "}
                <rect width="28" height="20" rx="2" fill="white"></rect>{" "}
                <mask
                  id="mask0_503_3600"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="28"
                  height="20"
                >
                  {" "}
                  <rect width="28" height="20" rx="2" fill="white"></rect>{" "}
                </mask>{" "}
                <g mask="url(#mask0_503_3600)">
                  {" "}
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5.33333H28V0H0V5.33333Z"
                    fill="#DD172C"
                  ></path>{" "}
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 20H28V14.6667H0V20Z"
                    fill="#DD172C"
                  ></path>{" "}
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 14.6667H28V5.33334H0V14.6667Z"
                    fill="#FFD133"
                  ></path>{" "}
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.33337 9.33333H8.66671V10H7.33337V9.33333Z"
                    fill="#FFEDB1"
                  ></path>{" "}
                  <path
                    d="M6.39116 8.99999H8.27543C8.47044 8.99999 8.6238 9.16666 8.60761 9.361L8.43633 11.4164C8.39314 11.9347 7.95987 12.3333 7.43978 12.3333H7.2268C6.70671 12.3333 6.27345 11.9347 6.23026 11.4164L6.05898 9.36101C6.04278 9.16667 6.19615 8.99999 6.39116 8.99999Z"
                    stroke="#A41517"
                    strokeWidth="0.666667"
                  ></path>{" "}
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 10H8.66667V10.6667H8L7.33333 12L6.66667 10.6667H6V10Z"
                    fill="#A41517"
                  ></path>{" "}
                  <rect
                    x="4"
                    y="8"
                    width="1.33333"
                    height="4.66667"
                    rx="0.666667"
                    fill="#A41517"
                  ></rect>{" "}
                  <rect
                    x="9.33337"
                    y="8"
                    width="1.33333"
                    height="4.66667"
                    rx="0.666667"
                    fill="#A41517"
                  ></rect>{" "}
                  <path
                    d="M6 7.73332C6 7.14422 6.47756 6.66666 7.06667 6.66666H7.6C8.1891 6.66666 8.66667 7.14422 8.66667 7.73332V7.73332C8.66667 7.8806 8.54728 7.99999 8.4 7.99999H6.26667C6.11939 7.99999 6 7.8806 6 7.73332V7.73332Z"
                    fill="#A41517"
                  ></path>{" "}
                </g>{" "}
              </g>{" "}
              <defs>
                {" "}
                <clipPath id="clip0_503_3600">
                  {" "}
                  <rect width="28" height="20" rx="2" fill="white"></rect>{" "}
                </clipPath>{" "}
              </defs>{" "}
            </g>
          </svg>
          <p>ES</p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            width: "80px",
          }}
        >
          <svg
            width="30px"
            height="30px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M3 5.5C3 14.0604 9.93959 21 18.5 21C18.8862 21 19.2691 20.9859 19.6483 20.9581C20.0834 20.9262 20.3009 20.9103 20.499 20.7963C20.663 20.7019 20.8185 20.5345 20.9007 20.364C21 20.1582 21 19.9181 21 19.438V16.6207C21 16.2169 21 16.015 20.9335 15.842C20.8749 15.6891 20.7795 15.553 20.6559 15.4456C20.516 15.324 20.3262 15.255 19.9468 15.117L16.74 13.9509C16.2985 13.7904 16.0777 13.7101 15.8683 13.7237C15.6836 13.7357 15.5059 13.7988 15.3549 13.9058C15.1837 14.0271 15.0629 14.2285 14.8212 14.6314L14 16C11.3501 14.7999 9.2019 12.6489 8 10L9.36863 9.17882C9.77145 8.93713 9.97286 8.81628 10.0942 8.64506C10.2012 8.49408 10.2643 8.31637 10.2763 8.1317C10.2899 7.92227 10.2096 7.70153 10.0491 7.26005L8.88299 4.05321C8.745 3.67376 8.67601 3.48403 8.55442 3.3441C8.44701 3.22049 8.31089 3.12515 8.15802 3.06645C7.98496 3 7.78308 3 7.37932 3H4.56201C4.08188 3 3.84181 3 3.63598 3.09925C3.4655 3.18146 3.29814 3.33701 3.2037 3.50103C3.08968 3.69907 3.07375 3.91662 3.04189 4.35173C3.01413 4.73086 3 5.11378 3 5.5Z"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>{" "}
            </g>
          </svg>
          <svg
            width="30px"
            height="30px"
            viewBox="0 0 32 32"
            version="1.1"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <title>comment-2</title> <desc>Created with Sketch Beta.</desc>{" "}
              <defs> </defs>{" "}
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                {" "}
                <g
                  id="Icon-Set"
                  transform="translate(-152.000000, -255.000000)"
                  fill="#000000"
                >
                  {" "}
                  <path
                    d="M168,281 C166.832,281 165.704,280.864 164.62,280.633 L159.912,283.463 L159.975,278.824 C156.366,276.654 154,273.066 154,269 C154,262.373 160.268,257 168,257 C175.732,257 182,262.373 182,269 C182,275.628 175.732,281 168,281 L168,281 Z M168,255 C159.164,255 152,261.269 152,269 C152,273.419 154.345,277.354 158,279.919 L158,287 L165.009,282.747 C165.979,282.907 166.977,283 168,283 C176.836,283 184,276.732 184,269 C184,261.269 176.836,255 168,255 L168,255 Z M175,266 L161,266 C160.448,266 160,266.448 160,267 C160,267.553 160.448,268 161,268 L175,268 C175.552,268 176,267.553 176,267 C176,266.448 175.552,266 175,266 L175,266 Z M173,272 L163,272 C162.448,272 162,272.447 162,273 C162,273.553 162.448,274 163,274 L173,274 C173.552,274 174,273.553 174,273 C174,272.447 173.552,272 173,272 L173,272 Z"
                    id="comment-2"
                  >
                    {" "}
                  </path>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
        </div>
      </div>
    </header>
  );
};

export default Header;
